// Booking primitives and shared booking-page pieces. The website templates
// (classic, monique, montserrat), their renderer and editor were removed in
// Oct 2026; only what the standalone booking page, member page, quote page and
// appointment review page use remains.

// ---------------------------------------------------------------------------
// Cloudflare Images variant helpers
// ---------------------------------------------------------------------------
export { getPublicSrc, getLargeSrc } from "./photoVariants";

// ---------------------------------------------------------------------------
// Photo carousel for member pages
// ---------------------------------------------------------------------------
export { MemberPhotoCarousel } from "./booking/MemberPhotoCarousel";
export type {
  MemberPhotoCarouselProps,
  MemberPhotoCarouselPhoto,
} from "./booking/MemberPhotoCarousel";

// ---------------------------------------------------------------------------
// Responsive booking layout (used by web appointment pages)
// ---------------------------------------------------------------------------
export {
  MobileBookingDrawer,
  useDrawerBack,
} from "./booking/MobileBookingDrawer";
export type { MobileBookingDrawerProps } from "./booking/MobileBookingDrawer";
export { DesktopBookingDrawer } from "./booking/DesktopBookingDrawer";
export type { DesktopBookingDrawerProps } from "./booking/DesktopBookingDrawer";

export {
  BookingMemberBooking,
  BookingUserAppointment,
  BookingScheduleBooking,
  BookingDateSelector,
  useBookingDate,
  bookingTimeZoneFor,
  BookingTimeButton,
  BookingOpeningLoading,
  BookingSelectService,
  LocationStep,
  MemberPanelShell,
  MemberTagBadges,
  BookingThemeRoot,
  bookingLightTheme,
  bookingDarkTheme,
  resolveBookingTheme,
  buildBookingCssVars,
  bookingColumnStyle,
  bookingStackGapStyle,
  bookingSectionTitleStyle,
  bookingPageTitleStyle,
  bookingSmallStyle,
  bookingBodyStyle,
  bookingCardStyle,
  selectedLocationSummaryStyle,
  selectedLocationCopyStyle,
  locationChangeButtonStyle,
  memberPanelStyle,
  memberPanelDimmedStyle,
  memberHeaderStyle,
  avatarStyle,
  avatarPlaceholderStyle,
  memberInfoStyle,
  memberNameStyle,
  memberMetaStyle,
  slotsContainerStyle,
  appointmentHeaderStyle,
  appointmentHeaderTitleStyle,
  timeButtonStyle,
  bookingPrimaryActionStyle,
  memberInfoPanelStyle,
  infoPhotosStyle,
  infoPhotoStyle,
  infoBtnStyle,
  consultationRequestBtnStyle,
  consultationRequestBtnHoverCss,
  dateInputContainerStyle,
  dateInputButtonStyle,
  dateInputLabelStyle,
  ConsultationDrawer,
  ServiceConsultation,
  ServiceRequestForm,
} from "./booking";
export type {
  BookingAppointmentForm,
  BookingOpeningsClient,
  BookingUser,
  BookingUserAppointmentProps,
  BookingScheduleBookingProps,
  SelectedService,
  ScheduleSummary,
  LocationSummary,
  ScheduleStepProps,
  LocationStepProps,
  MemberPanelShellProps,
  MemberTagView,
  BookingTheme,
  BookingThemeMode,
  BookingThemeRootProps,
  ConsultationService,
  ServiceRequestPayload,
  MediaUploadFn,
} from "./booking";

export {
  resolveBackgroundImageUrl,
  resolveColor,
  resolveFontSize,
  resolveFontWeight,
  resolveMaxWidth,
  resolveMinHeight,
  resolveTextAlign,
  SECTION_WIDTH_DEFAULT,
  TEMPLATE_MAX_WIDTH_VAR,
  TEMPLATE_FONT_SIZE_VAR,
  TEMPLATE_LINK_CLASSNAME,
  TEMPLATE_LINK_FONT_SIZE_VAR,
  TEMPLATE_LINE_HEIGHT_BODY,
  TEMPLATE_LINE_HEIGHT_TIGHT,
  TEMPLATE_SECTION_PADDING_X,
  TEMPLATE_SECTION_PADDING_Y,
  TEMPLATE_SPACING,
  TEMPLATE_TEXT_MUTED_OPACITY,
  TEMPLATE_TYPE_SCALE,
  TEMPLATE_COLOR,
  TEMPLATE_RADIUS,
  TEMPLATE_SHADOW,
  TEMPLATE_BORDER,
} from "./TemplateSectionStyle";

export { interceptPreviewClicks } from "./templates";
export { tenantAntdTheme } from "./templates/tenantAntdTheme";
export { renderBooking } from "./templates/renderBooking";
export { AppointmentReviewPage } from "./templates/shared/review";
export type {
  TemplateData,
  SalonInfo,
  TemplateBookingPreview,
  ScheduleBookingConfig,
  MemberBookingConfig,
} from "./templates";

// Sample media for the /dev booking harnesses.
export {
  buildSampleMediaImages,
  buildSamplePhotoItems,
} from "./editor/sampleMedia";
